export default {
  // fieldでの絞り込みセレクトボックス作成用
  selectDataListFlag: false,
  // ダイアログ用flag
  graphDialogFlag: false,
  // アグリノート画像モーダル用flag
  agrinoteImgFlag: false,
  // アグリノートメイン画像モーダル用flag
  agrinoteMainImgFlag: false,
  // 右側生育状況用
  sensorDataFlag: false,
  // 一覧の詳細データ用
  fieldDetailsDataFlag: false,
  // 一覧の詳細データ用
  modalFieldDetailsDataFlag: false,
  // グラフマスターデータ用
  graphMasterDataFlag: false,
  // plantingId用
  setPlantingIdFlag: false,
  // グラフ年変更用
  graphChangeDisplayYear: false,
  // 詳細ダイアログ用フラグ
  growthDialogFlag: false,
  comparisonPlantFlag: false,
  comparisonMasterFlag: false
}
